/**
 * StoryCard.jsx — Carte de réussite partageable (story 9:16)
 * ==========================================================
 * 100% styles INLINE en hex/rgba (pas de classe Tailwind / variable CSS oklch)
 * pour une capture html2canvas fiable. Rendue à 360×640, exportée ×3 (1080×1920).
 * Premium Dark Luxury, anonymisée, "Propulsé par Homly" discret mais visible.
 */
import React, { forwardRef } from 'react';

const ACCENTS = {
    emerald: { main: '#34D399', glow: '#0E3D30' },
    violet: { main: '#A855F7', glow: '#2A1147' },
    orange: { main: '#FF914D', glow: '#3A1E0B' },
    gold: { main: '#F5C451', glow: '#3A2E0B' },
};

const StoryCard = forwardRef(function StoryCard({ card, agentName }, ref) {
    if (!card) return null;
    const a = ACCENTS[card.accent] || ACCENTS.violet;

    return (
        <div
            ref={ref}
            data-testid="story-card"
            style={{
                width: 360,
                height: 640,
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 28,
                boxSizing: 'border-box',
                padding: 30,
                display: 'flex',
                flexDirection: 'column',
                fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
                color: '#FFFFFF',
                background: `radial-gradient(125% 85% at 82% 4%, ${a.glow} 0%, #0B0712 56%)`,
            }}
        >
            {/* Brand */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <div
                    style={{
                        width: 30, height: 30, borderRadius: 9,
                        background: `linear-gradient(135deg, #681793, ${a.main})`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 800, fontSize: 17, color: '#fff',
                    }}
                >H</div>
                <span style={{ fontSize: 17, fontWeight: 700, letterSpacing: 0.3 }}>Homly</span>
            </div>

            {/* Contenu central */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2.5, textTransform: 'uppercase', color: a.main }}>
                    {card.kicker}
                </span>

                <div style={{ fontSize: 30, fontWeight: 800, lineHeight: 1.12, marginTop: 12, color: '#FFFFFF' }}>
                    {card.headline}
                </div>

                {card.metric && (
                    <div style={{ marginTop: 18 }}>
                        <div style={{ fontSize: 78, fontWeight: 900, lineHeight: 1, color: a.main }}>{card.metric}</div>
                        {card.metric_label && (
                            <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.62)', marginTop: 4 }}>{card.metric_label}</div>
                        )}
                    </div>
                )}

                {card.quote && (
                    <div style={{ marginTop: 18 }}>
                        <div style={{ fontSize: 48, fontWeight: 900, color: a.main, lineHeight: 0.6, height: 26 }}>“</div>
                        <div style={{ fontSize: 21, fontStyle: 'italic', lineHeight: 1.4, color: '#F2ECFB', marginTop: 6 }}>
                            {card.quote}
                        </div>
                    </div>
                )}

                {card.subtext && (
                    <div style={{ fontSize: card.quote ? 16 : 14, color: card.type === 'review' ? a.main : 'rgba(255,255,255,0.6)', marginTop: 14, letterSpacing: card.subtext.includes('★') ? 3 : 0 }}>
                        {card.subtext}
                    </div>
                )}
            </div>

            {/* Footer */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.10)', paddingTop: 16 }}>
                {agentName && (
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#FFFFFF' }}>{agentName}</div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 4 }}>
                    <span style={{ width: 6, height: 6, borderRadius: 6, background: a.main, display: 'inline-block' }} />
                    <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.52)', letterSpacing: 0.4 }}>
                        Propulsé par <span style={{ color: 'rgba(255,255,255,0.85)', fontWeight: 600 }}>Homly</span>
                    </span>
                </div>
            </div>
        </div>
    );
});

export default StoryCard;
